import { configureStore } from "@reduxjs/toolkit";
import noticesSlice from "../features/notice/noticesSlice";
import profileSlice from "../features/profile/profileSlice";
import groupsSlice from "../features/messages/groupsSlice";
import notificationsSlice from "../features/notifications/notificationsSlice";
import positionSlice from "../features/position/positionSlice";
import noticeCategoryNotificationsSlice from "../features/noticeCategoryNotifications/noticeCategoryNotificationsSlice";

export const store = configureStore({
  reducer: {
    positions: positionSlice,
    profiles: profileSlice,
    notices: noticesSlice,
    groups: groupsSlice,
    notifications: notificationsSlice,
    noticeCategoryNotifications: noticeCategoryNotificationsSlice,
  },
});

